import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../actions/index.types';
import * as req from '../../../../axios/request/SocietyController/CtrlSocietyManagementReqs/CtrlSocietyManagementReqs';
import { notify } from '../../../../utils/notification';

/* =========================
   GET COMMUNITY LIST
========================= */
function* getCommunities(action) {
    try {
        const result = yield call(req.getCommunityListReq, action);

        if (result?.success === true) {
            yield put({
                type: types.CTRL_COMMUNITY_LIST_SUCCESS,
                payload: result
            });
        } else {
            notify('error', result?.message);
            yield put({
                type: types.CTRL_COMMUNITY_LIST_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.CTRL_COMMUNITY_LIST_FAILURE,
            message: e?.message
        });
    }
}

// /* =========================
//    GET COMMUNITY DETAILS
// ========================= */
function* getCommunityDetails(action) {
    try {
        const result = yield call(req.getCommunityDetailsReq, action);

        if (result?.success === true) {
            yield put({
                type: types.CTRL_GET_COMMUNITY_DETAILS_SUCCESS,
                payload: result?.data
            });
        } else {
            notify('error', result?.message);
            yield put({
                type: types.CTRL_GET_COMMUNITY_DETAILS_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.CTRL_GET_COMMUNITY_DETAILS_FAILURE,
            message: e?.message
        });
    }
}

// /* =========================
//    CREATE COMMUNITY
// ========================= */
function* createCommunity(action) {
    try {
        const result = yield call(req.createCommunityReq, action);

        if (result?.success === true) {
            notify('success', 'Society created successfully');
            yield put({
                type: types.CTRL_CREATE_COMMUNITY_SUCCESS,
                payload: result
            });
            // data.admin carries the one-time temporaryPassword for the new
            // SOCIETY_ADMIN login — the form shows it before leaving the page.
            action?.data?.onSuccess?.(result?.data);
        } else {
            // Validation 400s prefix the text with "body: "
            const message = String(result?.message || 'Something went wrong').replace(/^body:\s*/, '');
            notify('error', message);
            yield put({
                type: types.CTRL_CREATE_COMMUNITY_FAILURE,
                message
            });
            action?.data?.onError?.(message);
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.CTRL_CREATE_COMMUNITY_FAILURE,
            message: e?.message
        });
        action?.data?.onError?.(e?.message);
    }
}

// /* =========================
//    EDIT COMMUNITY
// ========================= */
function* editCommunity(action) {
    try {
        const result = yield call(req.editCommunityReq, action);

        if (result?.success === true) {
            notify('success', action?.data?.successMessage || result.message);
            yield put({
                type: types.CTRL_EDIT_COMMUNITY_SUCCESS,
                payload: result
            });
            // Refresh list after update
            action?.data?.onSuccess?.(result?.data)
        } else {
            // Validation 400s prefix the text with "body: "
            const message = String(result?.message || 'Something went wrong').replace(/^body:\s*/, '');
            notify('error', message);
            yield put({
                type: types.CTRL_EDIT_COMMUNITY_FAILURE,
                message
            });
            action?.data?.onError?.(message);
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.CTRL_EDIT_COMMUNITY_FAILURE,
            message: e?.message
        });
        action?.data?.onError?.(e?.message);
    }
}

// /* =========================
//    DELETE COMMUNITY
// ========================= */
function* deleteCommunity(action) {
    try {
        const result = yield call(req.deleteCommunityReq, action);

        if (result?.success === true) {
            notify('success', result.message);
            yield put({
                type: types.CTRL_DELETE_COMMUNITY_SUCCESS,
                payload: result
            });
            // Refresh list after delete
            action?.data?.onSuccess()
        } else {
            notify('error', result?.message);
            yield put({
                type: types.CTRL_DELETE_COMMUNITY_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        yield put({
            type: types.CTRL_DELETE_COMMUNITY_FAILURE,
            message: e?.message
        });
    }
}

/* =========================
   ROOT COMMUNITY SAGA
========================= */
export default function* ctrlCommunityManagementSaga() {
    yield takeLatest(types.CTRL_COMMUNITY_LIST, getCommunities);
    yield takeLatest(types.CTRL_GET_COMMUNITY_DETAILS, getCommunityDetails);
    yield takeLatest(types.CTRL_CREATE_COMMUNITY, createCommunity);
    yield takeLatest(types.CTRL_EDIT_COMMUNITY, editCommunity);
    yield takeLatest(types.CTRL_DELETE_COMMUNITY, deleteCommunity);
}
